import { Reveal, Overline } from "./Reveal";

const ABOUT_IMG =
    "https://images.unsplash.com/photo-1786284684390-5a810cb31da0?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzR8MHwxfHNlYXJjaHwzfHxsdXh1cnklMjBmYXNoaW9uJTIwYWNjZXNzb3JpZXMlMjBkYXJrfGVufDB8fHx8MTc4Njg3MTgzMHww&ixlib=rb-4.1.0&q=85";

export default function About() {
    return (
        <section id="about" data-testid="about-section" className="relative py-24 sm:py-32">
            <div className="max-w-7xl mx-auto px-6 lg:px-8 grid lg:grid-cols-12 gap-12 items-center">
                <div className="lg:col-span-7">
                    <Reveal>
                        <Overline>About LookAura</Overline>
                        <h2 className="mt-6 font-serif-display text-4xl sm:text-5xl tracking-tight text-[#FAFAFA]">
                            Style, understood <span className="italic text-amber-500">by AI</span>
                        </h2>
                    </Reveal>
                    <Reveal delay={0.1}>
                        <div className="mt-8 space-y-6 text-base sm:text-lg leading-relaxed text-zinc-400 max-w-2xl">
                            <p>
                                LookAura is an AI-powered appearance and fashion recommendation platform. It is designed to help people better understand their appearance and discover personalized style options — from clothing and accessories to hairstyles and complete looks.
                            </p>
                            <p>
                                By combining appearance analysis with your individual preferences, LookAura turns a photo into clear, actionable guidance — and connects that guidance to relevant products from participating online retailers.
                            </p>
                        </div>
                    </Reveal>
                </div>
                <Reveal delay={0.15} className="lg:col-span-5">
                    <div className="overflow-hidden border border-white/10 group" data-testid="about-image-frame">
                        <img
                            src={ABOUT_IMG}
                            alt="A gold wristwatch resting on dark velvet, evoking the precision and care behind LookAura's recommendations"
                            className="w-full h-72 sm:h-80 object-cover transition-transform duration-700 group-hover:scale-105"
                            loading="lazy"
                        />
                    </div>
                </Reveal>
            </div>
        </section>
    );
}
